import { render, staticRenderFns } from "./UpcomingEvents.vue?vue&type=template&id=c6f373b4&scoped=true&"
import script from "./UpcomingEvents.vue?vue&type=script&lang=js&"
export * from "./UpcomingEvents.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingEvents.vue?vue&type=style&index=0&id=c6f373b4&prod&scoped=true&lang=css&"
import style1 from "./UpcomingEvents.vue?vue&type=style&index=1&id=c6f373b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f373b4",
  null
  
)

export default component.exports